export const extractAffiliateCode = (location) => {
  const params = new URLSearchParams(location.search);
  const queryCode = params.get("ref");
  if (queryCode) return queryCode;

  const match = location.pathname.match(/\/partners\/([^/?#]+)/);
  if (match) return match[1];

  return null;
};